export default "__VITE_ASSET__BxyOIb5J__"